import React from 'react';
import { CheckCircle2Icon, LockIcon, MailIcon, ShieldCheckIcon } from 'lucide-react';
import { GoldPlaque } from '../ui/GoldPlaque';
import { CtaButton } from '../ui/CtaButton';
import { HeroMockup } from '../product/HeroMockup';
import { heroInclusions, heroTrust } from '../../data/site';
const trustIcons = {
  lock: LockIcon,
  mail: MailIcon,
  shield: ShieldCheckIcon
};
export function Hero() {
  return <section id="hero" aria-labelledby="hero-title" className="sport-hero relative overflow-hidden bg-ink text-white" data-id="element-31" data-mp="374xpswvsamyo">
      <div className="relative mx-auto grid max-w-page items-center gap-12 px-5 pb-12 pt-8 sm:pb-16 sm:pt-12 lg:grid-cols-[1.08fr_0.92fr] lg:px-8 lg:pb-24 lg:pt-16" data-id="element-32" data-mp="3c3iqsyiv1ao6">
        {/* Mobile first screen: title → mockup → button. Desktop: plaque → title → copy → checks → button → trust. */}
        <div className="flex flex-col items-center text-center lg:items-start lg:text-left" data-id="element-33" data-mp="1mr745wm9r7dr">
          <div className="order-1 hidden lg:block" data-id="element-34" data-mp="1qssdj7zlh3j7">
            <GoldPlaque data-id="element-35" data-mp="1qtk8qhpa4z8y">For PE teachers &amp; new youth coaches</GoldPlaque>
          </div>
          <h1 id="hero-title" className="order-2 font-display text-[38px] font-bold uppercase leading-[0.94] min-[400px]:text-[42px] sm:text-[58px] lg:mt-6 lg:text-[68px]" data-id="element-36" data-mp="230ex3m52d7pk">
            Plan your entire badminton season <span className="text-gold" data-id="element-37" data-mp="1oah50v40jxv3">in under 5 minutes.</span>
          </h1>

          <div className="order-3 mt-7 w-full lg:hidden" data-id="element-38" data-mp="2lx6bpi9nuyna">
            <HeroMockup data-id="element-39" data-mp="2lwoher6k6ui0" />
          </div>

          <div className="order-4 mt-7 w-full sm:w-auto lg:order-7 lg:mt-9" data-id="element-40" data-mp="2gymrpnemnwxk">
            <CtaButton target="offer" className="w-full sm:w-auto" data-id="element-41" data-mp="2gwikavhisfsj">
              Get the lesson pack
            </CtaButton>
          </div>

          <p className="order-5 mx-auto mt-7 max-w-xl text-base leading-relaxed text-white/80 sm:text-lg lg:mx-0" data-id="element-42" data-mp="26z5l93rjxf0j">
            Complete 40-minute beginner badminton lessons for ages 9–12,{' '}
            <span className="font-bold text-gold" data-id="element-43" data-mp="vkqx53sz5s7f">ready whenever badminton comes up in your year</span> — and yours to
            reuse every school year. Setup diagrams, step-by-step instructions and printable challenges included.
          </p>

          <ul aria-label="What you get" className="order-6 mt-5 grid grid-cols-2 gap-x-4 gap-y-2.5 text-left sm:flex sm:flex-wrap sm:justify-center sm:gap-x-5 lg:justify-start" data-id="element-44" data-mp="3nqgfkvjsaxb8">
            {heroInclusions.map(item => <li key={item} className="flex items-center gap-1.5 text-[15px] font-bold sm:text-base" data-id="element-45" data-mp="301x6wewtoiim">
                <CheckCircle2Icon aria-hidden="true" className="h-[18px] w-[18px] shrink-0 text-gold" data-id="element-46" data-mp="34uq9ox8qdgs2" />
                {item}
              </li>)}
          </ul>

          <ul className="order-8 mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 lg:justify-start" data-id="element-47" data-mp="2w0v8g0aqcahp">
            {heroTrust.map(item => {
            const Icon = trustIcons[item.icon];
            return <li key={item.label} className="flex items-center gap-1.5 text-sm text-white/75" data-id="element-48" data-mp="2m25o80vd2dya">
                  <Icon aria-hidden="true" className="h-4 w-4 text-gold" data-id="element-49" data-mp="22igh3jom2pyo" />
                  {item.label}
                </li>;
          })}
          </ul>
        </div>

        <div className="hidden lg:block" data-id="element-50" data-mp="2cg4hap4zkpo8">
          <HeroMockup data-id="element-51" data-mp="2cgwaxuf0wdbv" />
        </div>
      </div>
    </section>;
}